import React, { useState } from 'react';
import { Collapse } from 'reactstrap';
import EditMyRefModal from "./editProfileModals/EditMyRefModal";

const ReferenceCard = ({reference}) => {
    return (
        <div className="v-align mg-b-15">
            <div className="wd-pct-20 mg-r-15 b-r-border" >
            <div >
                <div>{reference.name}</div>
                <div>{reference.email}</div>
                <div>{reference.phone}</div>
            </div>
                
            </div>
            <div >
            <div className="card-list-header">{reference.relation}</div>
                <div className="card-list-subheader">{reference.association}</div>           
            </div>
        </div>    
    )
}

function MyReferences(props) {
    var { profile } = props.store
    var { references } = profile
    const [collapse, setCollapse] = useState(false);
    const toggle = () => setCollapse(!collapse);
    const [ newPlanModal, setNewPlanModal ] = useState(false);
    const toggleNewPlanModal = () => setNewPlanModal(!newPlanModal);
    return (
        <div className="mg-t-20" >
        <div className="card" >
            <div className="card-header">
                <div className="card-header-left">
                    <h5>References</h5>
                </div>
                <div className="card-header-right">
                    <ul className="row" >                        
                        <li><i className="far fa-edit" onClick={toggleNewPlanModal}></i></li>   
                        <li><i className={collapse ? "fa fa-chevron-down" : "fa fa-chevron-up"} onClick={toggle}></i></li>                                 
                        <EditMyRefModal modal={newPlanModal} toggle={toggleNewPlanModal} references={references} />
                    </ul>
                </div>
            </div>
            <Collapse isOpen={!collapse}>            
            <hr className="mg-l-20" ></hr>
            <div className="card-block">
                {references.map((reference, i) => (
                <>
                    <ReferenceCard reference={reference} />
                    {i != references.length - 1 ? <hr className="mg-r-0" ></hr> : null}
                </>))
                }
            </div>
            </Collapse>
    </div>
    </div>
        
    );
  }

export default MyReferences